export default __webpack_public_path__ + "static/media/confirm_phone.dc448f51.svg";